var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("div", { staticClass: "loading_holder" }, [
        _c("div", { staticClass: "spinner_holder" }, [_c("c-spinner")], 1)
      ])
    : _c(
        "v-container",
        [
          _vm.noneFound
            ? _c(
                "div",
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-snackbar",
                        {
                          attrs: {
                            bottom: _vm.y === "bottom",
                            left: _vm.x === "left",
                            "multi-line": _vm.mode === "multi-line",
                            right: _vm.x === "right",
                            timeout: _vm.timeout,
                            top: _vm.y === "top",
                            vertical: _vm.mode === "vertical"
                          },
                          model: {
                            value: _vm.snackbar,
                            callback: function($$v) {
                              _vm.snackbar = $$v
                            },
                            expression: "snackbar"
                          }
                        },
                        [
                          _vm._v(
                            "\n        " + _vm._s(_vm.text) + "\n        "
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "pink", flat: "" },
                              on: {
                                click: function($event) {
                                  _vm.snackbar = false
                                }
                              }
                            },
                            [_vm._v("\n          Close\n        ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c(
                "v-flex",
                { attrs: { lg9: "", "offset-lg1": "", "mt-5": "" } },
                [
                  _c(
                    "v-card",
                    { attrs: { flat: "", id: "selectbox" } },
                    [
                      _c(
                        "v-container",
                        { attrs: { fluid: "" } },
                        [
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                xs12: "",
                                lg10: "",
                                "offset-lg3": "",
                                "ml-5": "",
                                "align-center": "",
                                wrap: ""
                              }
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.items,
                                  attach: "",
                                  chips: "",
                                  name: "categories",
                                  id: "categories",
                                  label: "categories",
                                  required: "",
                                  multiple: ""
                                },
                                on: {
                                  blur: function($event) {
                                    _vm.updateCon(
                                      _vm.categories,
                                      _vm.def,
                                      _vm.arts,
                                      _vm.noneFound,
                                      _vm.snackbar
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.categories,
                                  callback: function($$v) {
                                    _vm.categories = $$v
                                  },
                                  expression: "categories"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "", "mb-5": "" } },
            [
              _vm._l(_vm.def, function(art) {
                return _vm.def.length != 0
                  ? _c(
                      "v-flex",
                      {
                        key: art.id,
                        attrs: {
                          xs12: "",
                          lg10: "",
                          "offset-lg2": "",
                          "mt-5": "",
                          "mr-5": ""
                        }
                      },
                      [
                        _c(
                          "v-card",
                          { attrs: { "mt-3": "" } },
                          [
                            _c("v-card-media", {
                              attrs: { img: "", src: art.url }
                            }),
                            _vm._v(" "),
                            _c(
                              "v-card-title",
                              { attrs: { "primary-title": "" } },
                              [
                                _c("div", [
                                  _c("h3", { staticClass: "headline mb-0" }, [
                                    _vm._v(_vm._s(art.art_title))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    _vm._l(art.categories, function(
                                      tag,
                                      index
                                    ) {
                                      return _c(
                                        "v-chip",
                                        {
                                          key: tag.id,
                                          model: {
                                            value: art.categories[index],
                                            callback: function($$v) {
                                              _vm.$set(
                                                art.categories,
                                                index,
                                                $$v
                                              )
                                            },
                                            expression: "art.categories[index]"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(art.categories[index]) +
                                              " "
                                          )
                                        ]
                                      )
                                    })
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-card-actions",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      flat: "",
                                      color: "primary",
                                      router: "",
                                      to: "/art"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.clicked_art(art.upload_date)
                                      }
                                    }
                                  },
                                  [_vm._v("View")]
                                ),
                                _vm._v(" "),
                                _c("v-spacer"),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { flat: "", color: "primary" },
                                    on: {
                                      click: function($event) {
                                        _vm.submit_art(art)
                                      }
                                    }
                                  },
                                  [_vm._v("Submit this piece")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm._l(_vm.arts, function(art) {
                return _vm.def.length == 0
                  ? _c(
                      "v-flex",
                      {
                        key: art.id,
                        attrs: {
                          xs12: "",
                          lg10: "",
                          "offset-lg2": "",
                          "mt-5": "",
                          "mr-5": ""
                        }
                      },
                      [
                        _c(
                          "v-card",
                          { attrs: { "mt-3": "" } },
                          [
                            _c("v-card-media", {
                              attrs: { img: "", src: art.url, height: "450px" }
                            }),
                            _vm._v(" "),
                            _c(
                              "v-card-title",
                              { attrs: { "primary-title": "" } },
                              [
                                _c("div", [
                                  _c("h3", { staticClass: "headline mb-0" }, [
                                    _vm._v(_vm._s(art.art_title))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    _vm._l(art.categories, function(
                                      tag,
                                      index
                                    ) {
                                      return _c(
                                        "v-chip",
                                        {
                                          key: tag.id,
                                          staticClass: "display_chips",
                                          attrs: { close: "" },
                                          on: {
                                            input: function($event) {
                                              _vm.removeChip(
                                                art.upload_date,
                                                art.categories
                                              )
                                            }
                                          },
                                          model: {
                                            value: art.categories[index],
                                            callback: function($$v) {
                                              _vm.$set(
                                                art.categories,
                                                index,
                                                $$v
                                              )
                                            },
                                            expression: "art.categories[index]"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(art.categories[index]) +
                                              " "
                                          )
                                        ]
                                      )
                                    })
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-card-actions",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      flat: "",
                                      color: "primary",
                                      router: "",
                                      to: "/art"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.clicked_art(art.upload_date)
                                      }
                                    }
                                  },
                                  [_vm._v("View")]
                                ),
                                _vm._v(" "),
                                _c("v-spacer"),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { flat: "", color: "primary" },
                                    on: {
                                      click: function($event) {
                                        _vm.submit_art(art)
                                      }
                                    }
                                  },
                                  [_vm._v("Submit this piece")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              })
            ],
            2
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32ca4dcf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32ca4dcf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/artists/artist_dashboard.vue
// module id = null
// module chunks = 